export const API = process.env.VUE_APP_API;
export const cognitoConfig = {
    userPoolId: 'us-east-1_3nmeo2L6N', 
    userPoolClientId: '6lu57nm5l62dkc3t2rquhpp5sr', 
    region: 'us-east-1' 
}

